export const dateLocales: { [localeKey: string]: () => Promise<ILocale> } = {
  ar: async () => {
    await import("moment/dist/locale/ar");
    return await import("dayjs/locale/ar");
  },
  bg: async () => {
    await import("moment/dist/locale/bg");
    return await import("dayjs/locale/bg");
  },
  ca: async () => {
    await import("moment/dist/locale/ca");
    return await import("dayjs/locale/ca");
  },
  cs: async () => {
    await import("moment/dist/locale/cs");
    return await import("dayjs/locale/cs");
  },
  da: async () => {
    await import("moment/dist/locale/da");
    return await import("dayjs/locale/da");
  },
  de: async () => {
    await import("moment/dist/locale/de");
    return await import("dayjs/locale/de");
  },
  el: async () => {
    await import("moment/dist/locale/el");
    return await import("dayjs/locale/el");
  },
  en: async () => {
    await import("moment/dist/locale/en-gb");
    return await import("dayjs/locale/en");
  },
  es: async () => {
    await import("moment/dist/locale/es");
    return await import("dayjs/locale/es");
  },
  et: async () => {
    await import("moment/dist/locale/et");
    return await import("dayjs/locale/et");
  },
  eu: async () => {
    await import("moment/dist/locale/eu");
    return await import("dayjs/locale/eu");
  },
  fi: async () => {
    await import("moment/dist/locale/fi");
    return await import("dayjs/locale/fi");
  },
  fr: async () => {
    await import("moment/dist/locale/fr");
    return await import("dayjs/locale/fr");
  },
  he: async () => {
    await import("moment/dist/locale/he");
    return await import("dayjs/locale/he");
  },
  hr: async () => {
    await import("moment/dist/locale/hr");
    return await import("dayjs/locale/hr");
  },
  hu: async () => {
    await import("moment/dist/locale/hu");
    return await import("dayjs/locale/hu");
  },
  it: async () => {
    await import("moment/dist/locale/it");
    return await import("dayjs/locale/it");
  },
  ja: async () => {
    await import("moment/dist/locale/ja");
    return await import("dayjs/locale/ja");
  },
  kk: async () => {
    await import("moment/dist/locale/kk");
    return await import("dayjs/locale/kk");
  },
  ko: async () => {
    await import("moment/dist/locale/ko");
    return await import("dayjs/locale/ko");
  },
  lt: async () => {
    await import("moment/dist/locale/lt");
    return await import("dayjs/locale/lt");
  },
  lv: async () => {
    await import("moment/dist/locale/lv");
    return await import("dayjs/locale/lv");
  },
  nl: async () => {
    await import("moment/dist/locale/nl");
    return await import("dayjs/locale/nl");
  },
  no: async () => {
    await import("moment/dist/locale/nb");
    return await import("dayjs/locale/nb");
  },
  pl: async () => {
    await import("moment/dist/locale/pl");
    return await import("dayjs/locale/pl");
  },
  "pt-br": async () => {
    await import("moment/dist/locale/pt-br");
    return await import("dayjs/locale/pt-br");
  },
  ro: async () => {
    await import("moment/dist/locale/ro");
    return await import("dayjs/locale/ro");
  },
  ru: async () => {
    await import("moment/dist/locale/ru");
    return await import("dayjs/locale/ru");
  },
  sk: async () => {
    await import("moment/dist/locale/sk");
    return await import("dayjs/locale/sk");
  },
  sl: async () => {
    await import("moment/dist/locale/sl");
    return await import("dayjs/locale/sl");
  },
  sv: async () => {
    await import("moment/dist/locale/sv");
    return await import("dayjs/locale/sv");
  },
  th: async () => {
    await import("moment/dist/locale/th");
    return await import("dayjs/locale/th");
  },
  tr: async () => {
    await import("moment/dist/locale/tr");
    return await import("dayjs/locale/tr");
  },
  uk: async () => {
    await import("moment/dist/locale/uk");
    return await import("dayjs/locale/uk");
  },
  vi: async () => {
    await import("moment/dist/locale/vi");
    return await import("dayjs/locale/vi");
  },
  zh: async () => {
    await import("moment/dist/locale/zh-cn");
    return await import("dayjs/locale/zh");
  },
  "zh-tw": async () => {
    await import("moment/dist/locale/zh-tw");
    return await import("dayjs/locale/zh-tw");
  },
};

export const loadDateLocale = async (locale: string): Promise<ILocale | null> => {
  if (dateLocales[locale]) {
    return await dateLocales[locale]();
  } else {
    console.warn(`Date locale "${locale}" not found, using default locale.`);
    return null;
  }
};
